import React, { useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import {
  Box,
  Heading,
  SimpleGrid,
  Text,
  Image,
  Button,
  VStack,
  useToast,
} from "@chakra-ui/react";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import { getImageUrl } from "utils/ImageImporter";
import { tutors } from "utils/data/tutors";

function RadioCard({ tutor, isSelected, onSelect }) {
  return (
    <Box
      as="div"
      onClick={() => onSelect(tutor.id)}
      width="100%"
      cursor="pointer"
    >
      <Box
        borderWidth="2px"
        borderRadius="xl"
        p={4}
        textAlign="center"
        boxShadow="md"
        borderColor={isSelected ? "teal.500" : "gray.200"}
        bg={isSelected ? "teal.100" : "white"}
        _hover={{ borderColor: "teal.300" }}
      >
        <VStack spacing={3}>
          <Image
            boxSize="80px"
            src={getImageUrl(tutor.avatar)}
            alt={tutor.name}
            borderRadius="full"
          />
          <Heading size="md">{tutor.name}</Heading>
          <Text fontSize="sm" color="gray.600">
            {tutor.description}
          </Text>
        </VStack>
      </Box>
    </Box>
  );
}

function TutorSelectionForm({ tutorId }) {
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  function updateTutor(tutor) {
    setIsSubmitting(true);
    api
      .patch(`${API_BASE}/api/user/tutor?tutor=${tutor}`)
      .then((res) => {
        if (res.status == 200) {
          toast({
            title: `You selected ${tutor}`,
            status: "success",
            duration: 2000,
            isClosable: true,
          });
        }
      })
      .catch((e) => console.log("Failed to update tutor! error: ", e))
      .finally(() => setIsSubmitting(false));
  }

  return (
    <Formik
      initialValues={{ tutor: tutorId || "" }}
      enableReinitialize
      onSubmit={(values) => {
        updateTutor(values.tutor);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Box maxW="6xl" mx="auto" p={8}>
            <Heading as="h3" size="md" color={"teal"} mb={6} textAlign="center">
              Choose Your Writing Tutor
            </Heading>
            <SimpleGrid columns={{ sm: 1, md: 2 }} spacing={6}>
              {tutors.map((tutor) => (
                <RadioCard
                  key={tutor.id}
                  tutor={tutor}
                  isSelected={values.tutor === tutor.id}
                  onSelect={(id) => setFieldValue("tutor", id)}
                />
              ))}
            </SimpleGrid>
            <Box textAlign="center" mt={8}>
              <Button
                type="submit"
                colorScheme="green"
                isDisabled={isSubmitting || !values.tutor}
              >
                Confirm Selection
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

TutorSelectionForm.propTypes = {
  tutor: PropTypes.string, 
};

export default TutorSelectionForm;
